import React from "react";
import useStyles from "../styles";
import {Typography} from "@material-ui/core";

const TabLabel = ({isSelected, patientName, role}) => {
    const cl = useStyles();

    return (<div className={cl.tabLabel}>
        <Typography
            component="p"
            variant="body2"
            className={isSelected ? cl.tabLabelNameSelected : cl.tabLabelName}
            color={isSelected ? 'primary' : "initial"}
        >
            {patientName}
        </Typography>
        <Typography
            component="p"
            variant="body2"
            className={cl.tabLabelRole}
        >
            {role}
        </Typography>
    </div>);
};

export default TabLabel;
